import React from "react";
import Chart from "react-apexcharts";

const PageChart = ({ dates, pageStats }) => {
  const series = [
    {
      name: `Pages vues: ${pageStats.pv.reduce((a, b) => a + b, 0)}`,
      type: "line",
      data: pageStats.pv,
    },
    {
      name: `Clics: ${pageStats.clicks.reduce((a, b) => a + b, 0)}`,
      type: "line",
      data: pageStats.clicks,
    },
  ];

  const options = {
    colors: ["#3751FF", "#31D79F"],
    chart: {
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    title: {
      //   text: "Évolution de l'optimisation SEO de votre site web",
      style: {
        fontSize: "15px",
        fontWeight: "700",
        fontFamily: undefined,
        color: "rgba(0, 0, 0, 0.65)",
      },
    },
    dataLabels: {
      enabled: false,
      enabledOnSeries: [0],
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    labels: dates,
    xaxis: {
      type: "date",
      labels: {
        style: {
          fontFamily: "Red Hat Display, sans-serif",
          colors: "#9FA2B4",
        },
        rotate: -45,
        rotateAlways: false,

        showDuplicates: false,
        hideOverlappingLabels: true,
        trim: false,
      },
    },
    legend: {
      show: true,
      position: "top",
      fontFamily: "Red Hat Display, sans-serif",
      fontSize: "16px",
      horizontalAlign: "left",
      itemMargin: {
        horizontal: 15,
        vertical: 0,
      },
    },
    yaxis: {
      opposite: true,
      tickAmount: 4,
      max: Math.max(...pageStats.pv) + 10,
      forceNiceScale: true,
      labels: {
        style: {
          fontFamily: "Red Hat Display, sans-serif",
          colors: "#9FA2B4",
        },
      },
      crosshairs: {
        show: true,
        stroke: {
          color: "#3751FF",
        },
      },
    },
    tooltip: {
      style: {
        fontFamily: "Red Hat Display, sans-serif",
      },
      y: {
        title: {
          formatter: (seriesName) => seriesName.split(":")[0],
        },
      },
    },
    grid: {
      borderColor: "#EBEDF0",
    },
  };

  return (
    <div
      className="card-graph"
      style={{ height: "fit-content", padding: "20px 0px" }}
    >
      <Chart options={options} series={series} height={350} />
    </div>
  );
};

export default PageChart;
